<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="首頁">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            International Student Application System
          </li>
        </ol>
      </div>
    </nav>

    <div class="main form form_3">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>

      <div class="container">
        <div class="box" :class="{ 'submitted-readonly': isSubmitted }">
          <div class="title">
            <h2>International Student Application System</h2>
            <div class="btn_box">
              <button class="tours_btn" @click="startTour">
                <svg width="28" height="28" viewBox="0 0 28 28">
                  <defs>
                    <clipPath id="clip-path">
                      <rect id="_3" data-name="3" width="28" height="28" transform="translate(5575 10526)" fill="none"
                        stroke="#707070" stroke-width="1" />
                    </clipPath>
                  </defs>
                  <g id="icon_instructions" transform="translate(-5575 -10526)" clip-path="url(#clip-path)">
                    <g id="_2" data-name="2" transform="translate(5575.14 10526.5)">
                      <path id="_1" data-name="1"
                        d="M23.14,21.36a1,1,0,0,0,1-1V3.42A1.929,1.929,0,0,0,22.21,1.5H8.69V19.358h-2V1.5H5.93A3.077,3.077,0,0,0,2.86,4.57V22.43c0,.011.006.021.007.032A3.069,3.069,0,0,0,5.934,25.5h17.2a1,1,0,0,0,0-2H5.934a1.07,1.07,0,0,1,0-2.14H23.14Zm-7.751-15a1.007,1.007,0,0,1,1.021,1,1,1,0,0,1-2,0,1,1,0,0,1,.979-1ZM14.41,11.19a1,1,0,0,1,2,0v3.96a1,1,0,0,1-2,0Z"
                        fill="#580d63" />
                    </g>
                  </g>
                </svg>
                Instructions
              </button>
            </div>
          </div>

          <ul class="progress_bar">
            <li v-for="(item, index) in progressItems" :key="index">
              <router-link :to="item.to" :class="['step_box', getStepClass(index)]">
                <div class="step">
                  <p v-if="index != 6">Step {{ index + 1 }}</p>
                  <p v-else>Payment</p>
                  <p>{{ item.title }}</p>
                </div>
                <div class="line"></div>
              </router-link>
            </li>
          </ul>

          <!-- 已提交提示訊息 -->
          <div v-if="isSubmitted" class="bg" style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 15px 20px; margin-bottom: 20px;">
            <p style="margin: 0; color: #856404; font-weight: bold; font-size: 16px;">
              ⚠️ Application submitted and under review. View-only mode.
            </p>
          </div>

          <!-- 載入指示器 -->
          <div v-if="isLoading" class="loading-container" style="text-align: center; padding: 40px;">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
              <span class="sr-only">Loading...</span>
            </div>
            <p style="margin-top: 20px; font-size: 16px;">Loading form data...</p>
          </div>

          <template v-else>
            <!-- 步驟說明 -->
            <div class="bg">
              <div class="title_box description">
                <h3>{{ stepContent.title }}</h3>
              </div>
              <div v-if="stepContent.content" class="text_box" id="step1" v-html="stepContent.content"></div>
            </div>

            <!-- 推薦人列表 -->
            <div class="bg">
              <div class="block" id="step2">
                <div class="title_box">
                  <h3>Recommenders</h3>
                </div>

                <ul class="list">
                  <li class="title">
                    <div class="basis_250">Name</div>
                    <div class="basis_150">Job Title</div>
                    <div class="basis_250">School or Institute</div>
                    <div class="basis_250">Email</div>
                    <div class="basis_60">delete</div>
                  </li>

                  <li class="" v-for="(item, index) in recommenders" :key="item.asrId">
                    <div class="basis_250">{{ item.name }}</div>
                    <div class="basis_150">{{ item.jobTitle }}</div>
                    <div class="basis_250">{{ item.schoolOrInstitute }}</div>
                    <div class="basis_250">{{ item.email }}</div>
                    <div class="basis_60">
                      <button class="delete" @click="deleteRecommender(item.asrId)" :disabled="isSaving">
                        X
                      </button>
                    </div>
                  </li>

                  <li v-if="recommenders.length === 0" style="padding: 20px; text-align: center; color: #999;">
                    No recommenders added yet. Click "Add a New One" to add recommenders.
                  </li>
                </ul>

                <div class="btn_box">
                  <button class="btn add" id="step3" @click="showModal = true" :disabled="isSaving">
                    Add a New One
                  </button>
                </div>

                <!-- 新增推薦人彈窗 -->
                <div class="modal" v-if="showModal">
                  <div class="bg">
                    <div class="title_box">
                      <h3>Add New Recommender</h3>
                    </div>

                    <div :class="['form-group', { active: newPerson.name }]">
                      <input type="text" class="form-control" id="newPersonName" v-model="newPerson.name" required  :disabled="isSubmitted"/>
                      <label for="newPersonName"><span class="required">*</span>Name</label>
                    </div>

                    <div :class="['form-group', { active: newPerson.jobTitle }]">
                      <input type="text" class="form-control" id="newPersonJob" v-model="newPerson.jobTitle" required  :disabled="isSubmitted"/>
                      <label for="newPersonJob"><span class="required">*</span>Job Title</label>
                    </div>

                    <div :class="['form-group', { active: newPerson.schoolOrInstitute }]">
                      <input type="text" class="form-control" id="newPersonSchool" v-model="newPerson.schoolOrInstitute"
                        required  :disabled="isSubmitted"/>
                      <label for="newPersonSchool"><span class="required">*</span>School or Institute</label>
                    </div>

                    <div :class="['form-group', { active: newPerson.email }]">
                      <input type="email" class="form-control" id="newPersonEmail" v-model="newPerson.email" required  :disabled="isSubmitted"/>
                      <label for="newPersonEmail"><span class="required">*</span> Email</label>
                    </div>

                    <div class="btn_box">
                      <button class="btn" @click="saveNewRecommender" :disabled="isFormIncomplete || isSaving">
                        {{ isSaving ? 'Saving...' : 'Save' }}
                      </button>
                      <button class="btn" @click="cancelModal" :disabled="isSaving">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 各學程的推薦信邀請 -->
            <div class="bg" v-for="program in userPrograms" :key="program.pId">
              <div class="block">
                <div class="title_box">
                  <h3>
                    {{ program.name_EN }}
                  </h3>
                </div>

                <ul class="list">
                  <li class="title">
                    <div class="basis_40"></div>
                    <div class="basis_250">Name</div>
                    <div class="basis_250">Status / Action</div>
                    <div class="basis_60">delete</div>
                  </li>

                  <li class="" v-for="(letter, index) in getRecommendationLettersForProgram(program.pId)"
                    :key="letter.asrlId">
                    <div class="basis_40">
                      <div class="number">{{ index + 1 }}</div>
                    </div>
                    <div class="basis_250">
                      <p>{{ letter.recommenderName }}</p>
                    </div>

                    <div class="basis_250">
                      <template v-if="letter.status === 0">
                        <p v-if="!letter.lastSendTime">
                          Not sent
                          <button class="send_btn" @click="sendInvitation(letter.asrlId)" :disabled="isSaving">
                            Send Notice
                          </button>
                        </p>
                        <p v-else>
                          Sent {{ formatDateTime(letter.lastSendTime) }}
                          <button class="send_btn" @click="sendInvitation(letter.asrlId)" :disabled="isSaving">
                            Resend Notice
                          </button>
                        </p>
                      </template>
                      <template v-if="letter.status === 1">
                        <p class="opened">
                          Link Opened
                        </p>
                      </template>
                      <template v-if="letter.status === 2">
                        <p class="completed">
                          Completed
                        </p>
                      </template>
                    </div>

                    <div class="basis_60">
                      <button class="delete" @click="deleteRecommendationLetter(letter.asrlId)" :disabled="isSaving">
                        X
                      </button>
                    </div>
                  </li>

                  <li v-if="getRecommendationLettersForProgram(program.pId).length === 0"
                    style="padding: 20px; text-align: center; color: #999;">
                    No recommenders selected for this program yet.
                  </li>
                </ul>

                <div class="btn_box">
                  <button class="btn add" @click="openRecommenderSelector(program.pId)"
                    :disabled="recommenders.length === 0 || isSaving || isSubmitted">
                    Select Your Recommender
                  </button>
                </div>
              </div>
            </div>

            <!-- 選擇推薦人彈窗 -->
            <div class="modal" v-if="showRecommenderSelector">
              <div class="bg">
                <div class="title_box">
                  <h3>Select Recommender</h3>
                </div>

                <div style="margin: 20px 0;">
                  <p style="margin-bottom: 15px; color: #666;">
                    Please select a recommender for this program:
                  </p>
                  <select v-model="selectedRecommenderId" class="form-control"
                    style="width: 100%; padding: 10px; font-size: 16px;" :disabled="isSubmitted">
                    <option value="">-- Select a recommender --</option>
                    <option v-for="rec in availableRecommendersForProgram" :key="rec.asrId" :value="rec.asrId">
                      {{ rec.name }} ({{ rec.email }})
                    </option>
                  </select>
                </div>

                <div class="btn_box">
                  <button class="btn" @click="addRecommendationLetter" :disabled="!selectedRecommenderId || isSaving">
                    {{ isSaving ? 'Adding...' : 'Confirm' }}
                  </button>
                  <button class="btn" @click="closeRecommenderSelector" :disabled="isSaving">Cancel</button>
                </div>
              </div>
            </div>
          </template>

          <div class="btn_box" v-if="!isLoading">
            <button class="btn" @click="gotoPrev" :disabled="isSubmitted">Previous</button>
            <button class="btn" @click="gotoNext" :disabled="isSubmitted">Next</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import applyStudentService from "@/services/applyStudent.js";
import Swal from "sweetalert2";
import { driver } from "driver.js";

export default {
  name: "Form_3",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      // ========== 載入狀態 ==========
      isLoading: true,
      isSaving: false,
      isSubmitted: false, // 申請是否已提交

      // ========== 進度步驟 ==========
      currentStep: 2, // 表示第3步（index 2）
      progressItems: [
        { to: "/Apply/1", title: "Fill out online application form" },
        { to: "/Apply/2", title: "Apply for a program" },
        {
          to: "/Apply/3",
          title:
            "Fill out Recommenders (Do Not Fill Out Without Notifying Your Recommenders in Advance.)",
        },
        { to: "/Apply/4", title: "Upload Required Documents 1" },
        { to: "/Apply/5", title: "Upload Required Documents 2" },
        { to: "/Apply/Check", title: "Review & Submit" },
        { to: "/Apply/Pay", title: "Pay Application Fee" },
      ],

      // ========== 使用說明步驟 ==========
      driverObj: null,
      arr: [
        {
          element: "#step1",
          popover: {
            description: "Step instructions and important notices",
            side: "top",
            align: "start",
          },
        },
        {
          element: "#step2",
          popover: {
            description: "Add and manage your recommenders here",
            side: "bottom",
            align: "start",
          },
        },
        {
          element: "#step3",
          popover: {
            description: "Click to add a new recommender",
            side: "top",
            align: "start",
          },
        },
      ],

      // ========== 步驟內容 ==========
      stepContent: {
        step: 3,
        title: 'Step 3',
        content: '',
        applyInfo: null
      },

      // ========== 申請表資料 ==========
      asId: null, // 申請表ID

      // ========== 推薦人資料 ==========
      recommenders: [], // 推薦人列表
      showModal: false, // 控制新增推薦人彈窗
      newPerson: {
        name: "",
        jobTitle: "",
        schoolOrInstitute: "",
        email: "",
      },

      // ========== 推薦信資料 ==========
      recommendationLetters: [], // 所有推薦信邀請
      userPrograms: [], // 使用者申請的學程列表

      // ========== 選擇推薦人彈窗 ==========
      showRecommenderSelector: false,
      selectedProgramId: null,
      selectedRecommenderId: null,

      aId: null, // 申請學期梯次ID
    };
  },

  computed: {
    /**
     * 檢查新增推薦人表單是否完整
     */
    isFormIncomplete() {
      const p = this.newPerson;
      return !p.name || !p.jobTitle || !p.schoolOrInstitute || !p.email;
    },

    /**
     * 取得可選擇的推薦人（排除已選擇的）
     */
    availableRecommendersForProgram() {
      if (!this.selectedProgramId) return [];

      const existingRecommenderIds = this.recommendationLetters
        .filter(letter => letter.pId === this.selectedProgramId && letter.status !== 99)
        .map(letter => letter.asrId);

      return this.recommenders.filter(
        rec => !existingRecommenderIds.includes(rec.asrId)
      );
    },
  },

  watch: {
    // 監控 isSubmitted 狀態並禁用所有表單元素
    isSubmitted: {
      handler(newValue) {
        this.$nextTick(() => {
          this.toggleFormElements(newValue);
        });
      },
      immediate: false
    }
  },

  async mounted() {
    window.scrollTo(0, 0);
    await this.initializeForm();

    // 初始化時檢查並禁用表單元素（如果已提交）
    this.$nextTick(() => {
      if (this.isSubmitted) {
        this.toggleFormElements(true);
      }
    });
  },

  methods: {
    // ========== 頁面初始化 ==========

    /**
     * 初始化表單 - 載入所有必要資料
     */
    async initializeForm() {
      this.isLoading = true;
      try {
        const checkResult = await applyStudentService.checkUserApplication();
        if (!checkResult.success || !checkResult.data ||
          !checkResult.data?.isReview ||
          checkResult.data?.isAgree != 1) {
          Swal.fire({
            icon: "warning",
            title: "Eligibility review not completed",
            text: "Please complete the dual citizenship check and agree to the terms and conditions first.",
            confirmButtonText: "OK"
          }).then(() => {
            this.$router.push("/Profile");
          });
          return;
        }

        // 載入使用者申請表資料
        await this.loadUserApplication();

        // 載入步驟內容
        await this.loadStepContent();

        // 載入推薦人列表
        await this.loadRecommenders();

        // 載入推薦信邀請列表
        await this.loadRecommendationLetters();
      } catch (error) {
        console.error("Form initialization error:", error);
        Swal.fire({
          icon: "error",
          title: "Initialization Failed",
          text: "Failed to initialize form. Please refresh the page.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 載入步驟內容
     */
    async loadStepContent() {
      const result = await applyStudentService.getActiveApplyStepContent(3, this.aId);
      if (result.success && result.data) {
        this.stepContent = result.data;
        if (!this.stepContent.title) {
          this.stepContent.title = 'Step 3';
        }
      } else {
        // 使用預設值
        this.stepContent = {
          step: 3,
          title: 'Step 3',
          content: '',
          applyInfo: null
        };
      }
    },

    /**
     * 載入使用者申請表資料
     */
    async loadUserApplication() {
      const result = await applyStudentService.getUserApplication();
      if (result.success && (!result.data || !result.data.hasApplication)) {
        // 顯示請先完成基本資料並跳轉回Apply/1頁面
        Swal.fire({
          icon: "warning",
          title: "Incomplete Basic Information",
          text: "Please complete your basic information first.",
          confirmButtonText: "OK"
        }).then(() => {
          this.$router.push("/Apply/1");
        });        
      }
      if (result.success && result.data) {
        this.aId = result.data.aId;
        this.asId = result.data.asId;
        this.isSubmitted = result.data.isSubmitted || false;

        // 解析使用者申請的學程
        if (result.data.applyPrograms) {
          try {
            const programIds = JSON.parse(result.data.applyPrograms);
            // 需要載入學程的詳細資訊
            await this.loadProgramDetails(programIds);
          } catch (error) {
            console.error("Error parsing applyPrograms:", error);
            this.userPrograms = [];
          }
        }
      } else {
        throw new Error(result.message || "Failed to load user application");
      }
    },

    /**
     * 載入學程詳細資訊
     */
    async loadProgramDetails(programIds) {
      const result = await applyStudentService.getActiveApplyPrograms(this.aId);
      if (result.success && result.data) {
        const allPrograms = result.data.programs || [];
        this.userPrograms = programIds
          .map(pId => allPrograms.find(p => p.pId === pId))
          .filter(p => p !== undefined);
      }
    },

    /**
     * 載入推薦人列表
     */
    async loadRecommenders() {
      if (!this.asId) return;

      const result = await applyStudentService.getRecommenders(this.asId);
      if (result.success && result.data) {
        this.recommenders = result.data;
      } else {
        console.error("Failed to load recommenders:", result.message);
        this.recommenders = [];
      }
    },

    /**
     * 載入推薦信邀請列表
     */
    async loadRecommendationLetters() {
      if (!this.asId) return;

      const result = await applyStudentService.getRecommendationLetters(this.asId);
      if (result.success && result.data) {
        // 只顯示未刪除的推薦信（status !== 99）
        this.recommendationLetters = result.data.filter(letter => letter.status !== 99);
      } else {
        console.error("Failed to load recommendation letters:", result.message);
        this.recommendationLetters = [];
      }
    },

    // ========== 推薦人管理 ==========

    /**
     * 儲存新推薦人
     */
    async saveNewRecommender() {
      if (this.isFormIncomplete) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Information",
          text: "Please fill in all required fields.",
          confirmButtonText: "OK"
        });
        return;
      }

      // 驗證 email 格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.newPerson.email)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Email",
          text: "Please enter a valid email address.",
          confirmButtonText: "OK"
        });
        return;
      }

      this.isSaving = true;
      try {
        const recommenderData = {
          asId: this.asId,
          name: this.newPerson.name.trim(),
          jobTitle: this.newPerson.jobTitle.trim(),
          schoolOrInstitute: this.newPerson.schoolOrInstitute.trim(),
          email: this.newPerson.email.trim(),
        };

        const result = await applyStudentService.addRecommender(recommenderData);

        if (result.success) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Recommender added successfully!",
            confirmButtonText: "OK"
          });

          // 重新載入推薦人列表
          await this.loadRecommenders();

          // 關閉彈窗並清空表單
          this.cancelModal();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: result.message || "Failed to add recommender. Please try again.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Save recommender error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while saving. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    /**
     * 刪除推薦人
     */
    async deleteRecommender(asrId) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This will delete the recommender and all their recommendation letter invitations!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel"
      });

      if (!result.isConfirmed) return;

      this.isSaving = true;
      try {
        const deleteResult = await applyStudentService.deleteRecommender(asrId);

        if (deleteResult.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Recommender has been deleted.",
            confirmButtonText: "OK"
          });

          // 重新載入資料
          await this.loadRecommenders();
          await this.loadRecommendationLetters();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: deleteResult.message || "Failed to delete recommender.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Delete recommender error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while deleting. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    /**
     * 取消新增推薦人
     */
    cancelModal() {
      this.newPerson = {
        name: "",
        jobTitle: "",
        schoolOrInstitute: "",
        email: "",
      };
      this.showModal = false;
    },

    // ========== 推薦信管理 ==========

    /**
     * 取得特定學程的推薦信列表
     */
    getRecommendationLettersForProgram(pId) {
      return this.recommendationLetters.filter(letter => letter.pId === pId);
    },

    /**
     * 開啟推薦人選擇器
     */
    openRecommenderSelector(pId) {
      if (this.recommenders.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Recommenders",
          text: "Please add recommenders first before selecting them for programs.",
          confirmButtonText: "OK"
        });
        return;
      }

      this.selectedProgramId = pId;
      this.selectedRecommenderId = null;
      this.showRecommenderSelector = true;
    },

    /**
     * 關閉推薦人選擇器
     */
    closeRecommenderSelector() {
      this.selectedProgramId = null;
      this.selectedRecommenderId = null;
      this.showRecommenderSelector = false;
    },

    /**
     * 新增推薦信邀請
     */
    async addRecommendationLetter() {
      if (!this.selectedRecommenderId) {
        Swal.fire({
          icon: "warning",
          title: "No Selection",
          text: "Please select a recommender.",
          confirmButtonText: "OK"
        });
        return;
      }

      this.isSaving = true;
      try {
        const invitationData = {
          asId: this.asId,
          pId: this.selectedProgramId,
          asrId: this.selectedRecommenderId,
        };

        const result = await applyStudentService.addRecommendationLetterInvitation(invitationData);

        if (result.success) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Recommender has been added to this program!",
            confirmButtonText: "OK"
          });

          // 重新載入推薦信列表
          await this.loadRecommendationLetters();

          // 關閉選擇器
          this.closeRecommenderSelector();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: result.message || "Failed to add recommendation letter invitation.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Add recommendation letter error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while adding. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    /**
     * 發送推薦信邀請
     */
    async sendInvitation(asrlId) {
      this.isSaving = true;
      try {
        const result = await applyStudentService.sendRecommendationLetterInvitation(asrlId);

        if (result.success) {
          Swal.fire({
            icon: "success",
            title: "Sent!",
            text: "Invitation email has been sent to the recommender.",
            confirmButtonText: "OK"
          });

          // 重新載入推薦信列表以更新發送時間
          await this.loadRecommendationLetters();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: result.message || "Failed to send invitation.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Send invitation error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while sending. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    /**
     * 刪除推薦信邀請
     */
    async deleteRecommendationLetter(asrlId) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This will remove this recommendation letter invitation.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel"
      });

      if (!result.isConfirmed) return;

      this.isSaving = true;
      try {
        const deleteResult = await applyStudentService.deleteRecommendationLetterInvitation(asrlId);

        if (deleteResult.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Recommendation letter invitation has been deleted.",
            confirmButtonText: "OK"
          });

          // 重新載入推薦信列表
          await this.loadRecommendationLetters();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: deleteResult.message || "Failed to delete invitation.",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error("Delete recommendation letter error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while deleting. Please try again.",
          confirmButtonText: "OK"
        });
      } finally {
        this.isSaving = false;
      }
    },

    // ========== 工具方法 ==========

    /**
     * 格式化日期時間
     */
    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mi = String(date.getMinutes()).padStart(2, "0");
      return `${yyyy}/${mm}/${dd} ${hh}:${mi}`;
    },

    /**
     * 進度步驟 不同狀態增加不同class
     */
    getStepClass(index) {
      if (index < this.currentStep) {
        return "done"; // 已完成
      } else if (index === this.currentStep) {
        return "filling"; // 目前步驟
      }
      return "";
    },

    /**
     * 開始使用說明導覽
     */
    startTour() {
      this.driverObj = driver({
        showProgress: true,
        progressText: "{{current}}/{{total}}",
        showButtons: true,
        nextBtnText: "Next",
        prevBtnText: "Back",
        doneBtnText: "End Tour",
        animate: false,
        steps: this.arr,
      });

      this.driverObj.drive();
    },

    // ========== 頁面導覽 ==========

    /**
     * 回到上一頁（Form 1）
     */
    gotoPrev() {
      this.$router.push("/Apply/2").then(() => {
        window.scrollTo(0, 0);
      });
    },

    /**
     * 前往下一頁（Form 3）
     */
    gotoNext() {
      this.$router.push("/Apply/4").then(() => {
        window.scrollTo(0, 0);
      });
    },

    /**
     * 切換表單元素的禁用狀態
     * @param {boolean} disable 是否禁用
     */
    toggleFormElements(disable) {
      // 使用 setTimeout 確保 DOM 已完全渲染
      setTimeout(() => {
        const container = document.querySelector('.box');
        if (!container) return;

        // 禁用所有 input (包含 text, radio, checkbox, file 等)
        const inputs = container.querySelectorAll('input:not(.tours_btn)');
        inputs.forEach(input => {
          input.disabled = disable;
        });

        // 禁用所有 select
        const selects = container.querySelectorAll('select');
        selects.forEach(select => {
          select.disabled = disable;
        });

        // 禁用所有 textarea
        const textareas = container.querySelectorAll('textarea');
        textareas.forEach(textarea => {
          textarea.disabled = disable;
        });

        // 禁用所有按鈕 (除了使用說明按鈕)
        const buttons = container.querySelectorAll('button:not(.tours_btn):not(.head-btn)');
        buttons.forEach(button => {
          button.disabled = disable;
        });
      }, 100);
    },
  },
};
</script>

<style scoped>
/* 當表單已提交時,禁用所有輸入元素 */
.submitted-readonly input,
.submitted-readonly select,
.submitted-readonly textarea,
.submitted-readonly button:not(.tours_btn) {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.submitted-readonly .form-check-input,
.submitted-readonly input[type="radio"],
.submitted-readonly input[type="checkbox"] {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.submitted-readonly .form-check-label {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}
</style>